/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: unified
 */
import React, { useCallback, useState } from 'react';
import { ModalShell } from '../../../shared/modals/ModalShell';
import { SupportTicketDetailPanel } from './SupportTicketDetailPanel';
import type { SupportTicketRow } from '../services/supportTicketsRepo';

type Props = {
  visible: boolean;
  ticketId: string | null;
  initialTicket?: SupportTicketRow | null;
  onClose: () => void;
  onTicketUpdated?: (ticket: SupportTicketRow) => void;
};

export function SupportTicketDetailModal({
  visible,
  ticketId,
  initialTicket,
  onClose,
  onTicketUpdated,
}: Props) {
  const [internalTicket, setInternalTicket] = useState<SupportTicketRow | null>(null);

  const handleTicketUpdated = useCallback(
    (ticket: SupportTicketRow) => {
      setInternalTicket(ticket);
      onTicketUpdated?.(ticket);
    },
    [onTicketUpdated]
  );

  return (
    <ModalShell
      visible={visible}
      onClose={onClose}
      onRequestClose={onClose}
      title="Detalle"
      closeAccessibilityLabel="Cerrar detalle"
      keyboardAvoiding
      scrollBottomInset={60}
      scrollContentStyle={{ padding: 0 }}
    >
      {ticketId ? (
        <SupportTicketDetailPanel
          ticketId={ticketId}
          initialTicket={initialTicket ?? internalTicket}
          scrollable={false}
          onTicketUpdated={handleTicketUpdated}
        />
      ) : null}
    </ModalShell>
  );
}
